"use client";

import dynamic from "next/dynamic";
import { SpotifyPlayerProvider, useSpotifyPlayer } from "./spotify-player-context";
import { DiscoveryAnalytics } from "../discovery/discovery-analytics";

const SpotifyPlayerBar = dynamic(
  () => import("./spotify-player-bar").then((m) => m.SpotifyPlayerBar),
  { ssr: false }
);

function SpotifyPlayer() {
  const { artistId } = useSpotifyPlayer();
  return artistId ? <SpotifyPlayerBar /> : null;
}

export function SpotifyLayoutProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SpotifyPlayerProvider>
      <DiscoveryAnalytics />
      {children}
      <SpotifyPlayer />
    </SpotifyPlayerProvider>
  );
}
